import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { resultQueryFn, resultMutationFn } from '@/shared/utils/queryHelpers';
import { queryKeys } from '@/shared/utils/queryKeys';
import { fetchHistory, fetchHistoryStats, deleteGeneration } from './api';

export function useHistory(limit: number = 20, offset: number = 0, status?: string) {
  return useQuery({
    queryKey: queryKeys.history.list(limit, offset, status),
    queryFn: resultQueryFn(() => fetchHistory(limit, offset, status)),
  });
}

export function useHistoryStats() {
  return useQuery({
    queryKey: queryKeys.history.stats,
    queryFn: resultQueryFn(fetchHistoryStats),
  });
}

export function useDeleteGeneration() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: resultMutationFn(deleteGeneration),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.history.all });
    },
  });
}
